declare namespace $ {

	type $mol_string__value_shm_hitalama_profile_page_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_page['login'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_hitalama_profile_page_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_page['save'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_labeler__title_shm_hitalama_profile_page_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_profile_page_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_button_major__title_shm_hitalama_profile_page_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_profile_page_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_page['save'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__enabled_shm_hitalama_profile_page_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_page['save_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_minor__title_shm_hitalama_profile_page_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_profile_page_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_page['exit'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_profile_page_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_copy__title_shm_hitalama_profile_page_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_button_copy__text_shm_hitalama_profile_page_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_page['secret_key'] >
		,
		ReturnType< $mol_button_copy['text'] >
	>
	type $mol_labeler__title_shm_hitalama_profile_page_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_profile_page_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_text__text_shm_hitalama_profile_page_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_page['message'] >
		,
		ReturnType< $mol_text['text'] >
	>
	export class $shm_hitalama_profile_page extends $mol_page {
		login( next?: string ): string
		save( next?: any ): any
		Login( ): $mol_string
		Login_label( ): $mol_labeler
		save_enabled( next?: boolean ): boolean
		Save( ): $mol_button_major
		exit( next?: any ): any
		Exit( ): $mol_button_minor
		Login_tools( ): $mol_view
		secret_key( ): string
		Secret_copy( ): $mol_button_copy
		Secret_label( ): $mol_labeler
		message( next?: string ): string
		Message( ): $mol_text
		title( ): string
		profiles( ): $shm_hitalama_profile_dict
		message_login_empty( ): string
		message_login_exists( ): string
		message_saved( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=page.view.tree.d.ts.map